import * as React from 'react';
import { OrderStatus } from '@websky/graphql';
import { useTranslation } from 'react-i18next';

interface Props {
	status: OrderStatus;
}

const OrderStatusText: React.FC<Props> = ({ status }) => {
	const { t } = useTranslation('OrderCard');

	switch (status) {
		case OrderStatus.Confirmed:
			return <>{t('Confirmed')}</>;
		case OrderStatus.Booked:
			return <>{t('Booked')}</>;
		case OrderStatus.Cancelled:
			return <>{t('Cancelled')}</>;
		case OrderStatus.Problematic:
			return <>{t('Problematic')}</>;
		default:
			return null;
	}
};

export default OrderStatusText;
